import { gql } from '@apollo/client'

export default gql`
  mutation CreateAppointmentInvite($input: AppointmentInviteInput!) {
    createAppointmentInvite(input: $input) {
      id
      duration_minutes
      notes_for_member
      preferred_profession
      preferred_medium
      allowed_mediums
      service_type {
        id
        name
        member_instructions
      }
    }
  }
`
